import React, { useId } from 'react';
import { Path, G, Defs, ClipPath } from 'react-native-svg';
import { IconWithGradient } from 'design-system/icons/Icon';
const IconTagSolid = (props) => {
    const id = useId();
    return (<IconWithGradient viewBox="0 0 24 24" id={id} width={24} height={24} defaultGradientKey="lightPink" {...props}>
      <G clipPath="url(#a)">
        <Path fill={`url(#gradient_${id})`} d="M6.179 4.592h4.944a2.11 2.11 0 0 1 1.495.62l5.821 5.82a2.12 2.12 0 0 1 0 2.996l-4.412 4.412a2.12 2.12 0 0 1-2.996 0l-5.82-5.821a2.11 2.11 0 0 1-.62-1.495V6.179c0-.876.711-1.587 1.588-1.587Zm2.117 4.762a1.057 1.057 0 1 0 0-2.116 1.058 1.058 0 1 0 0 2.116Z"/>
      </G>
      <Defs>
        <ClipPath id="a">
          <Path fill={`url(#gradient_${id})`} d="M4.591 3.533h14.817v16.934H4.591z"/>
        </ClipPath>
      </Defs>
    </IconWithGradient>);
};
export default IconTagSolid;
